import { RyeconClock } from '@dbt-labs/sourdough';

import DetailTabs, { TabInfo } from '@/components/DetailTabs';
import { useMacro } from '@/hooks/dbtStrategy/useMacro';
import { GenericResourceNode } from '@/hooks/discovery/types';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import {
  getResourceTypeHeaderIcon,
  ResourceDetailsHeader,
  TextIconPair,
} from '../Header';
import { Arguments } from '../Tabs/Arguments';
import { CodeView } from '../Tabs/CodeView';
import { GeneralView } from '../Tabs/GeneralView';

const tabs: TabInfo[] = [{ type: 'general' }, { type: 'arguments' }, { type: 'code' }];

type ResourceParams = {
  uniqueId: ParsedUniqueId;
};

export const MacroView = ({ uniqueId }: ResourceParams) => {
  const macroQuery = useMacro(uniqueId);

  if (macroQuery.error) return <>{macroQuery.error.stack}</>;
  const macro = macroQuery.fetching ? null : macroQuery.data;
  const updatedAt = undefined;
  const headerIcons: TextIconPair[] = [getResourceTypeHeaderIcon('macro')];
  if (updatedAt) {
    headerIcons.push({
      ryecon: RyeconClock,
      text: `Updated at ${updatedAt}`,
    });
  }
  return (
    <>
      <ResourceDetailsHeader
        uniqueId={uniqueId.raw}
        title={uniqueId.remainder}
        headerIcons={headerIcons}
        packageName={uniqueId.packageName}
        files={[macro?.definition?.patchPath, macro?.definition?.filePath]}
        name={macro?.definition?.name}
        resourceType="macro"
        updatedDate={updatedAt}
      />
      <DetailTabs tabs={tabs} show={!!macro}>
        {(activeTab) => {
          return (
            <>
              {activeTab === 'general' && (
                <GeneralView
                  resource={macro?.definition as GenericResourceNode}
                  uniqueId={uniqueId}
                  description={macro?.definition?.description}
                  meta={macro?.definition?.meta}
                />
              )}
              {activeTab === 'code' && macro?.definition?.macroSql && (
                <CodeView rawCode={macro.definition.macroSql} />
              )}
              {activeTab === 'arguments' && macro?.definition?.arguments && (
                <Arguments macroArguments={macro.definition.arguments} />
              )}
            </>
          );
        }}
      </DetailTabs>
    </>
  );
};
